import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import CongratulationsPage from "../CongratulationsPage";

const FinancingCalculator = React.lazy(() => import("../../containers/FinancingCalculator/EntrypointContainer"));

export const financingCalculatorRoutes: RouteObject[] = [
    {
        path: "/financing-calculator",
        component: <FinancingCalculator />,
        title: "Calculadora de Financiamiento"
    },
    {
        title: "Congratulations",
        path: "/financing-calculator/congratulations", 
        component: <CongratulationsPage title={"Consulta recibida."} text={"Un agente Linze se contactará contigo para encontrar la opción de financiamiento más conveniente."} />
    }
];
